import type { PdpPremiumBundleProduct } from 'components/discovery/pdp/typing/pdp-product.js'

export const formatGiftPrice = (gift: PdpPremiumBundleProduct, locale: string): string => {
  const amount = Number(gift.prices.sale_display)
  const currency = gift.prices.currency_code

  if (!currency) return Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)

  return Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount)
}
